//TODO: delete local rdg functions once this one is used, and refactor this one
export function getRDG(appName: string, userDoc: string): number | string | null {
  const acDigit = Number(userDoc.slice(6,9).replace('.', ''))
  const cpDigit = Number(userDoc.slice(5,7))
  const digitRule = appName === 'ac' ? acDigit : cpDigit

  const userRdg = !!userDoc ? digitRule : '';
  return userRdg;
}
